import React from 'react'

export const Loader = () => (
  <div className="loader">
    <div className="loader__inner">
      <span className="sr-text">Loading...</span>
    </div>
  </div>
)
